import { SxProps } from '@mui/system';
import Spacings from '../ds/theme/common/spacings';
import { solTheme } from '../ds/theme/SolThemeProvider';
import { TypographyOptions } from '@mui/material/styles/createTypography';

const backToLogin: SxProps = {
  textAlign: 'right',
  color: 'neutral.10',
  '& a': {
    marginLeft: Spacings.small2,
    fontWeight: (solTheme.typography as TypographyOptions)?.body3Medium,
  },
};

export default {
  backToLogin,
};
